// src/components/FeedbackModal.js
import React, { useEffect, useRef } from 'react';
import styles from './FeedbackModal.module.css'; // We'll create this CSS module next

const FeedbackModal = ({ isOpen, onClose, formUrl, gameName, onDismissPermanently }) => {
    const modalRef = useRef(null);

    // Close modal if clicked outside, but not if clicking the iframe content
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                // Check if the click was not inside the iframe
                if (event.target.tagName !== 'IFRAME') {
                    onClose();
                }
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent} ref={modalRef}>
                <h3 className={styles.modalTitle}>Share Your Thoughts on DeenRoute!</h3>
                <p className={styles.modalMessage}>
                    We'd love to hear your feedback to make DeenRoute even better.
                    Please take a moment to fill out this quick survey.
                </p>

                {/* The embedded Google Form/Typeform */}
                <iframe
                    src={formUrl}
                    className={styles.feedbackIframe}
                    title={`Feedback for ${gameName}`}
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                    allowFullScreen
                >
                    Loading feedback form...
                </iframe>

                <div className={styles.modalActions}>
                    <button className={styles.closeButton} onClick={onClose}>
                        Close
                    </button>
                    <button className={styles.dismissButton} onClick={onDismissPermanently}>
                        Don't Show Again
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
